import { Modal, Rating } from "@mui/material";
import React from "react";
import { IoCloseCircle } from "react-icons/io5";
import CustomerFeedbackApi from "../../../../../API/CustomerFeedbackApi";
import { useState } from "react";
import { useEffect } from "react";
import SearchCustomerFeedbackReq from "../../../../../Requests/CustomerFeedback/SearchCustomerFeedbackReq";
import ReviewContainer from "../../../../Reps/DigitalBusinessCenter/components/ReviewContainer";

const ReviewsModal = ({ user, open, setOpen }) => {
  const [reviews, setReviews] = useState([]);
  const [avgRating, setAvgRating] = useState(0);
  const [reviewCount, setReviewCount] = useState(0);

  const getReviews = async () => {
    const req = new SearchCustomerFeedbackReq();
    req.pagingParams.pageNumber = 1;
    req.pagingParams.pageSize = 1000;
    req.feedbackType = null;
    const res = await CustomerFeedbackApi.SearchCustomerFeedbacks(req);
    if (res?.status?.success) {
      let totalRating = 0;
      res.data.list.forEach((review) => {
        totalRating += review.rating;
      });
      setAvgRating(totalRating / res.data.totalItems);
      setReviewCount(res.data.totalItems);
      setReviews(res.data.list);
      console.log(res.data);
    }
  };

  useEffect(() => {
    getReviews();
  }, []);

  return (
    <Modal
      setOpen={setOpen}
      minHeight={"80vh"}
      padding={4}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <div
        // className="custom_modal"
        style={{
          maxHeight: "90vh",
          paddingTop: "20px",
            overflowY: "auto",
        }}
        className="bg-white p-4 rounded-lg shadow-lg flex flex-col gap-4 w-full max-w-lg"
      >
        <div className="flex items-center gap-4 justify-between">
            <h2 className="text-xl font-bold text-gray-800">Reviews</h2>
        <IoCloseCircle
          onClick={() => {
            setOpen(false);
          }}
          size={30}
          style={{ marginLeft: "auto", cursor: "pointer" }}
          color="#2761d0"
        />

        </div>
        <div>
        <ReviewContainer greater={true} />
          
        </div>
      </div>
    </Modal>
  );
};

export default ReviewsModal;
